import ModalImage from "react-modal-image";
import useUniversalStore from "store/universalStore";
import { transactionAPI, accountAPI } from "services";
import { formatDate, formatMoney } from "utils";
import useOffcanvasStore from "store/offcanvasStore";
import { confirm } from "components";

function Txn({ data, setLoading, handleToggle, loadTxns }) {
  const { accountId, write, selectedMonth, isSharedAccount } = useUniversalStore((state) => state);
  const { openOffcanvas } = useOffcanvasStore();

  let attachment = data.attachment;
  const isPDF = attachment?.includes(".pdf");
  //TODO : If filename contains invalid characters, then change filename to valid filename
  const isImage = attachment?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
  const text = data.detail;

  const handleModalOpen = () => {
    confirm({
      message: "You want to delete this <b>Transaction</b>",
      onConfirm: () => deletetransaction(data.id),
    });
  };

  const deletetransaction = async (id) => {
    setLoading(true);
    try {
      await transactionAPI.deleteTransaction(id);
      loadTxns?.()
      //Reset the transactionId
      write({
        transactionId: null,
        accounts: await accountAPI.getAccounts(),
      });
      handleToggle(false);
    } catch (err) {
      console.error("deletetransaction error: ", err);
    }
  };

  const editTransaction = () => {
    openOffcanvas("editTxn");
    write({ transactionId: data.id });
  }

  const cancelledView = () => {
    return (
      <div className="d-flex w-100 p-0 m-0 align-items-stretch position-relative" style={{ minHeight: '52px' }}>
        <div className="d-flex align-items-center justify-content-end col-md-3" style={{ minWidth: "50px" }}>
          <span className="fs-xmd-smaller text-nowrap text-muted text-decoration-line-through">
            {formatMoney(Math.abs(data.amount))}
          </span>
        </div>
        <div className="col-8 col-sm-9 p-1 ps-2 ps-md-3 pb-2 d-flex flex-column justify-content-center text-start position-relative">
          <div className="pe-3 pe-md-4 d-flex justify-content-between flex-column flex-md-row">
            <div className="text-muted text-decoration-line-through fs-xmd-smaller">
              <span className="text-break text-wrap">{text}</span>
            </div>
            <div className="text-muted fs-xmd-smaller ms-auto text-decoration-line-through" style={{ fontSize: '0.9rem' }}>
              <i className="text-nowrap">{formatDate(data.date)}</i>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const handleDownload = () => {
  //   const link = document.createElement('a');
  //   link.href = attachment;
  //   link.target = "_blank"
  //   link.download = 'filename.jpg'; 
  //   link.click();
  // };

  const normalView = () => {
    return (
      <>
        <div className="d-flex w-100 p-0 m-0 align-items-stretch position-relative" style={{ minHeight: '52px' }}>
          <div className="d-flex align-items-center justify-content-end col-md-3" style={{ minWidth: "50px" }}>
            <span className="fs-xmd-smaller text-nowrap text-dark">
              {formatMoney(Math.abs(data.amount))}
            </span>
          </div>
          <div className="col-8 col-sm-9 p-1 ps-2 ps-md-3 pb-2 d-flex flex-column justify-content-center text-start position-relative">
            {!isSharedAccount && <div className="position-absolute py-1 px-1 end-0" style={{ top: "5px" }}>
              <div className="dropdown">
                <a
                  className="text-black btn p-0 bg-not-transparent-on-hover w-auto"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  title="More options"
                >
                  <span className="bi bi-three-dots-vertical"></span>
                </a>
                <ul className="dropdown-menu dropdown-menu-end row w-auto">
                  <li className="col-12 py-1">
                    <button className="w-100 btn btn-outline-app rounded"
                      onClick={editTransaction}
                    >
                      <span className="bi bi-pencil-fill"> Edit</span>
                    </button>
                  </li>
                  <li className="col-12 py-1">
                    <button
                      className="w-100 btn btn-app rounded"
                      onClick={() => {
                        write({ transactionId: data.id })
                        handleModalOpen()
                      }}
                    >
                      <span className="bi bi-trash"> Delete</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>}

            <div className="pe-3 pe-md-4 d-flex justify-content-between flex-column flex-md-row">
              <div className="text-dark fs-xmd-smaller">
                <span className="text-break text-wrap">{text}</span>
                <span className={`ms-1 badge border border-2 ${data.type === "CREDIT" ? "text-secondary" : "d-none"}`} title="Transaction Type">CREDIT</span>
              </div>
              <div className="text-muted fs-xmd-smaller ms-auto" style={{ fontSize: '0.9rem' }}>
                <i className="text-nowrap">{formatDate(data.date)}</i>
              </div>
            </div>
          </div>
        </div>
        {(isImage || isPDF) && (
          <div className="col-6 mx-auto p-0 my-1">
            {isPDF && (
              <a role="button" href={attachment} target="_blank" rel="noreferrer" className="cursor-pointer d-inline-block">
                <i className="bi bi-file-pdf-fill text-danger fs-5" />
              </a>
            )}
            {isImage && (
              <div className="d-inline-block">
                <ModalImage
                  small={attachment}
                  large={attachment}
                  hideDownload={false}
                  hideZoom={false}
                  className="uploadbillpreview rounded border shadow-sm"
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  return (
    <div className="list-group-item bg-transparent p-0 border-bottom">
      {data.cancelled ? cancelledView() : normalView()}
    </div>
  );
}

export default Txn;
